import { Link } from "react-router-dom";

/**
 * The privacy policy Play and the App Store require. Plain statements of
 * what the app actually does — it is short because the app collects little.
 * Keep it true: if the app starts collecting something new, this changes in
 * the same commit.
 */
export function Privacy() {
  return (
    <div className="landing" style={{ maxWidth: 720 }}>
      <p className="chrome"><Link to="/">← BrainStorm</Link></p>
      <div className="head" style={{ marginTop: 24 }}>Privacy policy</div>
      <h1 style={{ marginTop: 8, fontSize: 36, lineHeight: "42px" }}>What BrainStorm keeps, and why.</h1>
      <p className="chrome">Last updated 7 September 2026 · Pessoa-Tech</p>

      <h3 style={{ marginTop: 36 }}>Reading without an account</h3>
      <p>You can browse the first cards without signing in. What you read and save stays on your phone. The app sends anonymous usage events to our servers — which cards were shown, opened, and read to the end — tagged with a random id generated on your device. That id is not linked to you, your device identifiers, or your Google account.</p>

      <h3 style={{ marginTop: 28 }}>If you sign in with Google</h3>
      <p>We receive your Google account id, name, email address and profile picture, and we store them so you can sign in again and see your own saved chains on another device. We also store what you saved, liked, read, and the categories you follow. Usage events from a signed-in session are linked to your account id.</p>
      <p>We do not use your data for advertising, we do not sell it, and we do not share it with anyone except the cloud provider that hosts it (Amazon Web Services, region Asia Pacific — Mumbai).</p>

      <h3 style={{ marginTop: 28 }}>What we do not collect</h3>
      <p>No location, no contacts, no device identifiers, no advertising id, no analytics SDKs from third parties. Sign-in uses Google's own sign-in service; Google's privacy policy applies to that step.</p>

      <h3 style={{ marginTop: 28 }}>Deleting your data</h3>
      <p>Signing out removes the session from your device. To delete your account and everything stored under it, email <a href="mailto:maunish.pessoa@gmail.com">maunish.pessoa@gmail.com</a> from the address you signed in with; it is removed within seven days. Anonymous usage events expire on their own after 90 days.</p>

      <h3 style={{ marginTop: 28 }}>Children</h3>
      <p>BrainStorm is not directed at children under 13 and does not knowingly collect information from them.</p>

      <h3 style={{ marginTop: 28 }}>Contact</h3>
      <p>Questions about this policy: <a href="mailto:maunish.pessoa@gmail.com">maunish.pessoa@gmail.com</a>.</p>
    </div>
  );
}
